import { ApiCore } from "./utilities/core";

export const meiliSearchAPI = (tenantSlug: string) => {
  return new ApiCore({
    getAll: true,
    getSingle: true,
    post: true,
    put: true,
    remove: true,
    url: `api/${tenantSlug}/conversation`,
  });
};
